// DateTimePicker provides a wrapper for consistent datetime picker look
// no "today" button available. PR pending
// https://github.com/mui-org/material-ui/pull/28091

// don't bother passing class or style, it'll be ignored
// https://mui.com/api/text-field/#css
import React from 'react';
// import { DateTimePicker } from '@mui/lab';
import { DateTimePicker, DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';

const StyledDateTimePicker = props => {
    return (
        <DateTimePicker
            {...props}
            renderInput={(props) => <TextField variant="standard" {...props} />}
            ampm={false}/>
    );
};

const StyledDatePicker = props => {
    return (
        <DatePicker
            {...props}
            renderInput={(props) => <TextField variant="standard" {...props} />}/>
    );
};

export {
    StyledDateTimePicker as default,
    StyledDatePicker
};
